'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}(); // Core React
// Local Components
// Local Styles


exports.default = VerticalTabs;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Card = require('../card/Card');

var _Card2 = _interopRequireDefault(_Card);

require('./verticalTabs.scss');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function VerticalTabs(props) {
  var tabsData = props.tabsData,
      defaultTabIndex = props.defaultTabIndex;

  var _useState = (0, _react.useState)(defaultTabIndex),
      _useState2 = _slicedToArray(_useState, 2),
      activeTab = _useState2[0],
      setActiveTab = _useState2[1];

  var handleClick = function handleClick(event) {
    setActiveTab(event.target.tabIndex);
  };

  return _react2.default.createElement(_Card2.default, {
    customClass: 'vertical-tab-width'
  }, _react2.default.createElement('div', {
    className: 'vertical-tabs'
  }, tabsData.map(function (tab, index) {
    return _react2.default.createElement('div', {
      key: tab.name,
      tabIndex: index,
      role: 'button',
      onClick: function onClick(e) {
        return handleClick(e);
      },
      onKeyPress: function onKeyPress(e) {
        return handleClick(e);
      },
      className: 'vertical-tab-name tab-' + index + ' ' + (activeTab === index ? 'vertical-active-tab' : 'vertical-nonactive-tab')
    }, _react2.default.createElement('div', {
      tabIndex: index
    }, tab.name));
  })), tabsData.map(function (tab, index) {
    return _react2.default.createElement('li', {
      key: tab.name,
      className: 'vertical-tab-body tab-' + index + ' ' + (activeTab === index ? 'vertical-active-tab-body' : 'vertical-nonactive-tab-body')
    }, tab.body);
  }), _react2.default.createElement('div', null));
}

VerticalTabs.propTypes = {
  defaultTabIndex: _propTypes2.default.number,
  tabsData: _propTypes2.default.shape({
    name: _propTypes2.default.string.isRequired,
    body: _propTypes2.default.node,
    active: _propTypes2.default.bool.isRequired
  })
};
VerticalTabs.defaultProps = {
  defaultTabIndex: 1,
  tabsData: {
    name: '',
    body: '',
    active: false
  }
};